import {NgModule} from '@angular/core';
import {RouterModule} from "@angular/router";
import {MARKETING_PAGE_ROUTES} from "./marketing-page.routes";

@NgModule({
    imports: [
        RouterModule.forChild(MARKETING_PAGE_ROUTES)
    ],
    exports: [
        RouterModule
    ]
})
export class MarketingPageRoutingModule { }
